<paper-dialog [open]="true" title="Switch desk" [bare]="true"
  [width]="'min(560px, calc(100vw - 24px))'"
  [closeOnEscape]="!saving()" [closeOnBackdrop]="!saving()" (closed)="closed.emit()">
  <section class="desk-change desk-move" data-testid="desk-exact-time-move" [attr.aria-busy]="saving() || context().checking">
    <header class="desk-change-head">
      <div>
        <h2>{{ context().saved ? 'Desk switched' : 'Switch to ' + context().targetSpaceName }}</h2>
        <p>{{ context().saved ? 'Your booking now sits at ' + context().targetSpaceName + '.' : 'Your booking keeps its exact times · ' + context().timezone }}</p>
      </div>
      <paper-button intent="ghost" shape="icon" icon="x" ariaLabel="Close desk switch" [disabled]="saving()" (click)="closed.emit()" />
    </header>
    <div class="desk-change-body">
      @if (!context().saved) {
        <fieldset class="desk-change-fieldset">
          <legend>{{ context().bookings.length > 1 ? 'Which booking moves?' : 'The booking that moves' }}</legend>
          <div class="desk-change-slots" [class.single]="context().bookings.length === 1">
            @for (booking of context().bookings; track booking.bookingId) {
              <button class="desk-change-slot" type="button" [disabled]="saving()"
                [class.selected]="context().selectedBookingId === booking.bookingId"
                [attr.aria-pressed]="context().selectedBookingId === booking.bookingId"
                [attr.data-booking-id]="booking.bookingId" (click)="selectBooking.emit(booking.bookingId)">
                <span class="desk-move-slot-head">
                  <strong>Desk {{ booking.spaceName }}</strong>
                  @if (phase(booking); as p) { <span class="desk-move-phase" [class.ended]="p === 'Ended'">{{ p }}</span> }
                </span>
                <span>{{ range(booking) }}</span>
              </button>
            }
          </div>
        </fieldset>
      }
      @if (selected(); as booking) {
        <div class="desk-move-route" [attr.role]="context().saved ? 'status' : null">
          <div class="desk-move-end">
            <span class="desk-move-end-label">{{ context().saved ? 'Was' : 'From' }}</span>
            <strong>Desk {{ booking.spaceName }}</strong>
          </div>
          <span class="desk-move-arrow" aria-hidden="true">→</span>
          <div class="desk-move-end desk-move-end-target">
            <span class="desk-move-end-label">{{ context().saved ? 'Now' : 'To' }}</span>
            <strong #receiptHeading tabindex="-1">Desk {{ context().targetSpaceName }}</strong>
          </div>
          <p class="desk-change-interval"><span>{{ range(booking) }}</span></p>
        </div>
      }
      @if (context().checking) { <p class="desk-move-status" role="status">Checking this desk for your booking…</p> }
      @if (context().error) {
        <p class="desk-change-error desk-move-error" role="alert">
          <paper-icon name="alert-circle" [size]="16" aria-hidden="true" />
          <span>{{ context().error }}</span>
        </p>
      }
      @if (!context().saved && !context().error && !context().checking && context().allowed) {
        <p class="desk-change-hint">Any other bookings stay where they are.</p>
      }
    </div>
    <footer class="desk-change-footer">
      <paper-button intent="secondary" [disabled]="saving()" (click)="closed.emit()">{{ context().saved ? 'Done' : 'Keep current desk' }}</paper-button>
      @if (!context().saved) {
        <paper-button intent="primary" [disabled]="saving() || context().checking || !context().allowed" (click)="confirmMove.emit()">{{ saving() ? 'Switching…' : 'Confirm desk switch' }}</paper-button>
      }
    </footer>
  </section>
</paper-dialog>
